import * as React from 'react'
import { ReactElement } from 'react'
import { EmailToolbarProps } from './EmailToolbar'
import DeleteDialog from '../../../components/Dialog/DeleteDialog'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import useProcessEmail from '../../../hooks/email/useProcessEmail'
import useUser from '../../../hooks/useUser'

export type DeleteEmailButtonProps = EmailToolbarProps & {
    userEmail: string // The e-mail address in which the e-mail resides. Can be the users or the replications.
}

export default function DeleteEmailButton(props: DeleteEmailButtonProps): ReactElement {
    const themeClassName = useThemeClassName_unstable()
    const { processSelection } = useProcessEmail()
    const user = useUser()
    const filterReferences = (references: string[]) =>
        references.filter(reference => reference !== props.file.data.reference)

    return (
        <DeleteDialog
            className={themeClassName}
            setPreventDefaultEvent={props.setPreventDefaultEvent}
            onDelete={setOpen =>
                processSelection(
                    props.userEmail,
                    user.email,
                    props.selection,
                    filterReferences,
                    () => {
                        props.setIsLoading(true)
                        setOpen(false)
                    },
                    props.reset,
                )
            }
        />
    )
}
